/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An addenda record which was added to an ACH transfer
 */
export type TransferACHAddendaRecord = {
  /**
   * The ACH addenda record, which may have masked PII
   */
  record: string;
  /**
   * Flag indicating whether or not this record has been masked
   */
  isMasked: boolean;
};

/** @internal */
export const TransferACHAddendaRecord$inboundSchema: z.ZodType<
  TransferACHAddendaRecord,
  z.ZodTypeDef,
  unknown
> = z.object({
  record: z.string(),
  isMasked: z.boolean(),
});
/** @internal */
export type TransferACHAddendaRecord$Outbound = {
  record: string;
  isMasked: boolean;
};

/** @internal */
export const TransferACHAddendaRecord$outboundSchema: z.ZodType<
  TransferACHAddendaRecord$Outbound,
  z.ZodTypeDef,
  TransferACHAddendaRecord
> = z.object({
  record: z.string(),
  isMasked: z.boolean(),
});

export function transferACHAddendaRecordToJSON(
  transferACHAddendaRecord: TransferACHAddendaRecord,
): string {
  return JSON.stringify(
    TransferACHAddendaRecord$outboundSchema.parse(transferACHAddendaRecord),
  );
}
export function transferACHAddendaRecordFromJSON(
  jsonString: string,
): SafeParseResult<TransferACHAddendaRecord, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TransferACHAddendaRecord$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TransferACHAddendaRecord' from JSON`,
  );
}
